<template>
  <static-fullscreen-card>
    <template v-slot:header></template>
    <template v-slot:actions>
      <v-btn color="primary" @click="$refs.table.updateData()"><btn-title icon="fas fa-sync-alt">Обновить</btn-title> </v-btn>
    </template>
    <portal to="v-main">
      <s-fileConfigDialog v-if="showEditDialog" v-model="showEditDialog" :id="idEdit" />
    </portal>
    <a-table-f-api ref="table" :api="url" :model="model" :useQuery="false" :defaults="defaults" @loadData="getModel($event)" @click="onClickRow($event)" />
    <su-Data v-if="getAccess('suData')" ref="suEdit" v-model="suEditShow" :api="url" :id="idEdit" :activate="!false" :dataEdit="dataEdit" @show="suEditShow = true" />
  </static-fullscreen-card>
</template>

<script>
import { autoHeightBlock, getAccess, genModel } from "@/components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess, genModel],
  components: {},
  data() {
    return {
      dataEdit: {},
      suEditShow: false,
      idEdit: 0,
      showEditDialog: false,
      title: "",
      //model: this.$store.getters["config/get"].models.info.list,
      m: this.$store.getters["config/get"].models.kontur,
      model: [],
      mm: {
        title: "",
        isDocument: false,
        api: "/kontur/admin",

        statuses: [
          { value: 1, text: "CREATED" },
          { value: 4, text: "SEND_TO_SIGN" },
          { value: 5, text: "CONFIRMED" },
          { value: 6, text: "SIGNED" },
          { value: 10, text: "DELETED" },
        ],
        targets: [{ value: "accounting_dir_contract", text: "Договор" }],
        list: [
          { name: "id", title: "#", type: "id", sortable: true, width: 40 },
          { name: "name", title: "name", type: "string", sortable: true, width: 120 },
          { name: "createdby_id", title: "Автор", type: "select", dir: "user", sortable: true, width: 80, style: "white-space: normal;" },
          { name: "createdon", title: "Создано", type: "datetime", sortable: true, width: 80, style: "white-space: normal;" },
          { name: "updatedon", title: "Изменено", type: "datetime", sortable: true, width: 80, style: "white-space: normal;" },
          { name: "target_name", title: "target_name", type: "select", sourceList: "targets", sortable: true, width: 150 },
          { name: "target_id", title: "target_id", type: "string", sortable: true, width: 60 },
          { name: "status", title: "Статус", type: "select", sourceList: "statuses", sortable: true, width: 100 },
        ],
      },
      url: "/kontur/admin",
      defaults: {
        sort: { key: "id", order: "DESC" },
        filters1: {
          "uploads_docs.parent_name": "accounting_doc_building_sell",
        },
      },
    };
  },
  created() {
    this.$root.title = this.$route.meta.title; // "Загруженные файлы";
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  computed: {
    model1() {
      return this.getModelList(this.m, false);
    },
  },
  methods: {
    autoModel(obj) {
      let model = this.model.copy();
      return model;
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          if (!model.find(m => m.name == key)) {
            model.push({ name: key, title: key, type: "variant" });
          }
        }
      }
      return model;
    },
    onClickRow(d) {
      this.dataEdit = Object.assign({}, d.row);
      console.log(this.dataEdit);
      this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.suEditShow = true;
    },
    async getModel(e) {
      console.log("bbbbb sss");
      let data = e?.[0] || {};
      this.model = this.getModelList(this.m, "list", false);
      let model = this.autoModel(data);
      this.model = model;
      console.log("bbbbb", model, this.m);
      return;
      //  let model = [];
      let f_doc = [
        { text: "Без документа", value: { condition: " is ", value: "null" } },
        { text: "Договор продажи", value: "accounting_doc_building_sell" },
        { text: "Договор покупки", value: "accounting_doc_building_buy" },
      ];
      model = [
        { name: "id", title: "#", type: "id", sortable: true, width: 50 },
        { name: "createdon", title: "Дата", type: "datetime", sortable: true, width: 120 },
        { name: "createdby_id", title: "Автор", type: "select", dir: "user", sortable: true, width: 180 },
        { name: "name", title: "Название", type: "string", sortable: true, width: 180 },
        {
          name: "doc_parent_name",
          title: "Документ",
          type: "string",
          filter: { name: "uploads_docs.parent_name", type: "select", options: f_doc },
          sortable: true,
          width: 180,
        },
      ];

      return model;
    },
  },
};
</script>
